<template>
  <el-form class="search_form" :model="searchForm" ref="searchForm" size="mini" :inline="true" :rules="searchFormRules">
    <!--搜索框-->
   
    <el-col :span="3">
      <el-form-item prop="ruleName">
        <el-input placeholder="费率名称" v-model="searchForm.ruleName" clearable></el-input>
      </el-form-item>
    </el-col>
  
    <el-col :span="1.5">
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="submitSearchForm" :loading="searchLoading">查询
        </el-button>
      </el-form-item>
    </el-col>
  </el-form>
</template>

<script>
import { validateInput } from '../../../../common/validator'
export default {
  name: "search",
  data() {
    return {
      searchFormRules: {
        ruleName: [
          {
            validator: function (rule, value, callback) {
              validateInput(rule, value, callback, 0, 12, true, true, false, false, false, false, false)
            }, trigger: 'blur'
          }],
      }
    }
  },
  props: {
    searchForm: {
      stationId: '',
      operatorId: ''
    },
    operatorForSelect: '',
    searchLoading: false,
  },
  created: function () {
    this._props.searchForm.stationId = sessionStorage.getItem('stationCode');
    this._props.searchForm.operatorId = sessionStorage.getItem('operatorId');
  },

  methods: {
    resetSearchForm() {
      for (let item in this.searchForm) {
        if (this.searchForm[item]) {
          this.searchForm[item] = ''
        }
      }
      this.submitSearchForm()
    },
    handleChangeOperator(value) {
      let operatorId = value && value.length > 0 ? value[value.length - 1] : ''
      this.searchForm.operatorId = operatorId
      this.$refs.cascader.dropDownVisible = false
    },
    submitSearchForm() {
      this.$emit("submitSearchForm")
    }
  },
  watch: {
    '$store.state.operatorId': {
      handler: function (newVal, oldVal) {
        this._props.searchForm.stationId = sessionStorage.getItem('stationCode');
        this._props.searchForm.operatorId = sessionStorage.getItem('operatorId');
        this.$emit("submitSearchForm")
      },
      deep: true
    }
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/rateManager/search.vue